import { automationOutreachStepTypes } from "@redotech/redo-model/split";
import * as z from "zod/v4";
import { automationOutreachSplitWithTreatmentsZodSchema } from "./get-automation-outreach-split";

const treatmentInputSchema_ = z.object({
  percentage: z.number().min(0).max(100),
  isControl: z.boolean().default(false),
  templateId: z.string().optional(),
  /** Client-provided name for the variant (e.g., "Variant A", "Variant B") */
  name: z.string().optional(),
});
export const treatmentInputSchema: z.ZodType<TreatmentInput> =
  treatmentInputSchema_;
export interface TreatmentInput extends z.infer<typeof treatmentInputSchema_> {}

export const createAutomationOutreachSplit = {
  name: "createAutomationOutreachSplit" as const,
  input: z.object({
    automationId: z.string(),
    automationStepId: z.string(),
    stepType: z.enum(automationOutreachStepTypes),
    name: z.string(),
    treatments: z.array(treatmentInputSchema),
    /**
     * The original templateId from the automation step.
     * If provided, this template will be copied for variant A,
     */
    originalTemplateId: z.string().optional(),
  }),
  output: automationOutreachSplitWithTreatmentsZodSchema,
};
